import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ErrorText from './ErrorText';
import Label from './Label';
import Button from '../Buttons/Button';
import Icon from '../Icons/Icon';

class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSeePassword: false,
    };
  }

  handleVisibilityClick = (e) => {
    e.preventDefault();
    this.setState({ canSeePassword: !this.state.canSeePassword });
  }

  render() {
    const { name, label, onChange, placeholder, value, error, touched, children, maxLength, onFocus, onBlur, inputRef, inputClass, required, classes } = this.props;
    const { canSeePassword } = this.state;

    const wrapperClass = classNames('password-input form-group', classes, {
      'form-group--has-error': touched && error,
    });

    return (
      <div className={wrapperClass}>
        <Label name={name} required={required}>{label}</Label>

        {children}

        <div className="field position-relative">
          <input
            id={name}
            type={canSeePassword ? 'text' : 'password'}
            name={name}
            className={`form-control ${inputClass}`}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            onFocus={onFocus}
            onBlur={onBlur}
            ref={inputRef}
          />

          <Button onClick={e => this.handleVisibilityClick(e)} classes="password-input__visibility-btn d-flex" tabIndex={-1} faux>
            {canSeePassword ? (
              <Icon name="eye-hidden" fill="green" size="s" />
            ) : (
              <Icon name="eye" fill="grey" size="s" />
            )}
          </Button>
        </div>

        {touched && error && <ErrorText>{error}</ErrorText>}
      </div>
    );
  }
}

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  maxLength: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inputRef: PropTypes.func,
  inputClass: PropTypes.string,
  required: PropTypes.bool,
  classes: PropTypes.string,
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/PasswordInput.js